export const getCanonicalAttr = (language, path) => {
  const langDomainMap = {
    en: 'https://help.seatalk.io',
    th: 'https://help.seatalk.in.th',
    id: 'https://help.seatalk.co.id',
    vi: 'https://help.seatalk.vn',
    zh_Hant: 'https://help.seatalk.tw',
  };

  const domain = langDomainMap[language] || langDomainMap.en;

  // can't use URL API since this function also run in server.
  // URL API is available only in browser
  // return `${domain}${path}`;
  const href = `${domain}${path}`;

  return { href, rel: 'canonical' };
};
